import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const { HOMEPAGE } = require('../config/config');
const { isExcluded } = require('../utils');

function ReloadHandler({ children }) {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    try {
      const [nav] = performance.getEntriesByType('navigation');
      if (!isExcluded() && nav && nav.type === 'reload') {
        const path = window.location.pathname;
        // 変更またはキャンセルページであるか確認
        const isChangeOrCancel = path.includes('change');
        // セッションストレージから予約識別子(小文字英数32桁)を取得
        const changeUrl = sessionStorage.getItem('changeUrl');
        let destination = '';
        if(isChangeOrCancel && changeUrl){
          destination = `${HOMEPAGE}/change/${changeUrl}`;
        }else {
          const lgCd = sessionStorage.getItem('lgCd');
          if (lgCd) {
            destination = `${HOMEPAGE}/${lgCd}`;
          }

          // idがついている場合
          const searchParams = window.location.search;
          if(searchParams){
            destination += searchParams;
          }
        }
        // ターゲットURLが設定されている場合、即座にリダイレクトしてページを切り替える
        if (destination) {
          window.location.replace(destination);
        }
      }else{
        setChecked(true);
      }
    } catch (e) {
      // セーフティ
      const lgCd = sessionStorage.getItem('lgCd');
      if (lgCd) {
        window.location.replace(`${HOMEPAGE}/${lgCd}`);
      }
    }
  }, []);

  if (checked) return children;

  return null;
}

ReloadHandler.propTypes = {
  children: PropTypes.node, // node = 文字列・要素・配列 なんでもOK
};

ReloadHandler.defaultProps = {
  children: null,
};

export default ReloadHandler;
